import { createSelector } from 'reselect';

const DEFAULT_OBJECT = {};

const getSocketReducerState = (state) => state?.socket || DEFAULT_OBJECT;

export const isSocketConnectedSelector = createSelector(
  getSocketReducerState,
  (socketReducerState) => socketReducerState?.connected
);
